import { render } from "./ParameterOptions.vue?vue&type=template&id=0e2fe338&scoped=true"
import script from "./ParameterOptions.vue?vue&type=script&lang=js"
export * from "./ParameterOptions.vue?vue&type=script&lang=js"

import "./ParameterOptions.vue?vue&type=style&index=0&id=0e2fe338&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2fe338"]])

export default __exports__